export const DownloadIcon = (props) => (
  <svg fill="none" height={24} viewBox="0 0 24 24" width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M3.88477 7.80768V18.8846C3.88614 19.3432 4.06892 19.7826 4.39321 20.1069C4.71749 20.4312 5.15693 20.614 5.61553 20.6154H17.3848C17.8434 20.614 18.2828 20.4312 18.6071 20.1069C18.9314 19.7826 19.1142 19.3432 19.1155 18.8846V7.80768"
      stroke={props.color ? props.color : "#303030"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.38462}
    />
    <path
      d="M19.2885 4H3.71154C3.04242 4 2.5 4.54242 2.5 5.21154V6.25C2.5 6.91911 3.04242 7.46154 3.71154 7.46154H19.2885C19.9576 7.46154 20.5 6.91911 20.5 6.25V5.21154C20.5 4.54242 19.9576 4 19.2885 4Z"
      stroke={props.color ? props.color : "#303030"}
      strokeLinejoin="round"
      strokeWidth={1.38462}
    />
    <path
      d="M14.2689 14.3846L11.4997 17.1538L8.73047 14.3846M11.4997 16.1971V10.923"
      stroke={props.color ? props.color : "#303030"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.38462}
    />
  </svg>
);
